import { render, staticRenderFns } from "./MenuNurse.vue?vue&type=template&id=fd1a6e52&"
import script from "./MenuNurse.vue?vue&type=script&lang=js&"
export * from "./MenuNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports